module.exports = " <table class=week-table border=1> <div class=\"week-head flex\"> </div> <tbody class=\"week-body flex\"> </tbody> </table> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/calendar.main/calendar.week/calendar.week.html
// module id = 4943
// module chunks = 50